import { Form, Row } from 'react-bootstrap'

import { Input } from '@presentation/components/molecules'
import { useForm } from '@presentation/hooks'

const EixoForm: React.FC = () => {
  const { register, formState, formId, onSubmit } = useForm()

  return (
    <Form id={formId} onSubmit={onSubmit}>
      <Row className="mb-3">
        <Input
          label="Nome"
          name="nome"
          register={register}
          error={formState.errors.nome?.message}
          required
          type="text"
          placeholder="Digite o nome do eixo"
          autoComplete="off"
        />
      </Row>
    </Form>
  )
}

export default EixoForm
